import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM3.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM10 7h3.133L15 9.353V13a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm2 1.5h-2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3H12V8.5Zm-7.5 2h-.125c-1.283 0-2.37.84-2.74 2H4.5a.75.75 0 0 1 0 1.5H.625A.625.625 0 0 1 0 13.375 4.375 4.375 0 0 1 4.375 9H4.5a.75.75 0 0 1 0 1.5Z';
const draw24px =
  'M9.5 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM16 11h4.6l2.4 3.235V20a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Zm3 1.5h-3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5H19v-2.5Zm-8.5 2H7.125a4.626 4.626 0 0 0-4.583 4H10.5a.75.75 0 0 1 0 1.5H1.875A.875.875 0 0 1 1 19.125 6.125 6.125 0 0 1 7.125 13H10.5a.75.75 0 0 1 0 1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PersonDocIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'personDoc'),
) as IconWithRender;

PersonDocIcon.displayName = 'PersonDocIcon';
PersonDocIcon.propTypes = Icon.propTypes;
PersonDocIcon.renderIcon = (props) => <PersonDocIcon {...props} />;
export default PersonDocIcon;
